/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { ServizioMensaRendicontazioneDTO } from './servizio-mensa-rendicontazione-dto';


export interface PagedModelServizioMensaRendicontazioneDTO { 
    content?: Array<ServizioMensaRendicontazioneDTO>;
    page?: PageMetadata;
}

